import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";

export default {
    storageKey: StorageKey.report_item_sales_collection,
    getReportLabel: () => t`Item Sales Collection`,
    getColumns: () => [],
};
